import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vuetify from 'vuetify/lib';
import Vue from 'vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#002554',
        secondary: '#FF671F'
      },
      dark: {}
    }
  },

  icons: {
    iconfont: 'mdiSvg'
  }
});
